import { ComponentProps, ReactElement } from 'react';

import { Button } from 'react-bootstrap';
import { getClasses } from '@/utils';

export type TimeInputItemProps = ComponentProps<typeof Button> & {
  name: 'Hour' | 'Minute' | 'Second';
  unit: number;
  selected?: boolean;
};

const TimeInputItem = ({ name, unit, selected, ...props }: TimeInputItemProps): ReactElement => (
  <li className={getClasses('TimeInput-Item', `TimeInput-${name}-${unit}`)}>
    <Button {...props} variant={getClasses(selected ? 'primary' : 'text')} tabIndex={-1}>
      {unit.toString().padStart(2, '0')}
    </Button>
  </li>
);

export default TimeInputItem;
